// 共通: 時給以外は金額を万単位に変換する処理
const convertToManUnit = (amount: number, mode: "round" | "floor" = "round"): string => {
  if (amount < 10000) {
    return amount.toLocaleString();
  }

  const value =
    mode === "floor"
      ? Math.floor((amount * 10) / 10000) / 10
      : Math.ceil((amount * 10) / 10000) / 10;

  return value.toString();
};

// 四捨五入（切り上げ）
export const formatSalaryPriceRound = (price: string | number): string => {
  if (!price) return "";
  const amount = Number(price);
  if (Number.isNaN(amount)) return "";
  return convertToManUnit(amount, "round");
};

// 切り捨て
export const formatSalaryPriceFloor = (price: string | number): string => {
  if (!price) return "";
  const amount = Number(price);
  if (Number.isNaN(amount)) return "";
  return convertToManUnit(amount, "floor");
};

// 雇用形態を給与表示用の省略した文字にする
export const omitEmploymentName = (employmentName: string) => {
  if (employmentName === "アルバイト・パート") return "ア";
  if (employmentName === "正社員") return "正";
  if (employmentName === "業務委託") return "委";
  if (employmentName === "契約社員") return "契";
  if (employmentName === "その他") return "他";
  return employmentName;
};

// 給与の単位を選択
export const chooseSalaryUnit = (price: string | number) => (Number(price) < 10000 ? "円" : "万円");
